export enum CONNECT_ACTION {
  SIGNUP = 'SIGNUP',
  SIGNIN = 'SIGNIN',
}
